var map = {
	"./absolicon/absolicon-image-link.svg": 9170,
	"./absolicon/absolicon-pannels.svg": 3779,
	"./absolicon/absolicon-person-1.svg": 1690,
	"./absolicon/absolicon-person-2.svg": 8981,
	"./absolicon/absolicon-person-3.svg": 1239,
	"./absolicon/absolicon-pie-chart.svg": 9893,
	"./absolicon/absolicon-robot.svg": 6659,
	"./danish-flag-icon.png": 205,
	"./easyfill/easyfill-fridge.svg": 7850,
	"./easyfill/easyfill-image-link.svg": 9446,
	"./easyfill/easyfill-person-1.svg": 8626,
	"./easyfill/easyfill-person-2.svg": 2916,
	"./easyfill/easyfill-person-3.svg": 8130,
	"./easyfill/easyfill-store.svg": 9720,
	"./easyfill/easyfill-zugut.svg": 4563,
	"./edger-finance-banner.svg": 6664,
	"./edger-finance-icon.svg": 5576,
	"./edger-finance-logo.png": 8239,
	"./edit-kpi-icon.svg": 709,
	"./english-flag-icon.svg": 5638,
	"./finnish-flag-icon.jpg": 3151,
	"./german-flag-icon.jpg": 6730,
	"./katalysen-background.svg": 4096,
	"./katalysen-ceo.svg": 9433,
	"./katalysen-cfo.svg": 212,
	"./katalysen-chart.svg": 3253,
	"./katalysen-cube.svg": 5393,
	"./katalysen-forest.svg": 7450,
	"./katalysen-image-link.svg": 7245,
	"./katalysen-investment-case-1.svg": 4050,
	"./katalysen-investment-case-2.svg": 1553,
	"./katalysen-investment-case-3.svg": 1560,
	"./katalysen-leadership-case-1.svg": 121,
	"./katalysen-leadership-case-2.svg": 7877,
	"./katalysen-leadership-case-3.svg": 4972,
	"./katalysen-media-play.svg": 9718,
	"./katalysen-media.svg": 1089,
	"./katalysen-member-of-board.svg": 6845,
	"./katalysen-minor-link-image-english.svg": 2453,
	"./katalysen-minor-link-image-swedish.svg": 5843,
	"./katalysen-people.svg": 7701,
	"./katalysen-sparkline.png": 2000,
	"./katalysen-sparkline.svg": 2902,
	"./katalysen.svg": 3529,
	"./linkedin-icon.svg": 9566,
	"./logo.png": 6949,
	"./media-icon.svg": 744,
	"./media-play-icon.svg": 4558,
	"./norwegian-flag-icon.png": 4897,
	"./pdf-icon.png": 686,
	"./pdf-icon.svg": 1407,
	"./powered-by-edger-finance.svg": 3155,
	"./presentation-icon.svg": 699,
	"./sensidose/sensidose-forest.svg": 3852,
	"./sensidose/sensidose-image-link.svg": 9472,
	"./sensidose/sensidose-milk-remote.svg": 8020,
	"./sensidose/sensidose-old-couple.svg": 8982,
	"./sensidose/sensidose-person-1.svg": 3664,
	"./sensidose/sensidose-person-2.svg": 9421,
	"./sensidose/sensidose-person-3.svg": 9570,
	"./slides-icon.png": 9120,
	"./swedish-flag-icon.svg": 4781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;